<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button v-if="inputForm&&inputForm.auditStatus=='1'&&type!='done'&&isTransact" size="small" style="width: 15%;margin-top: 2%;" type="info"
                    @click="show">办理
        </van-button>
        <van-button size="small" style="margin-left: 3%;width: 15%;" type="info" @click="close">返回</van-button>
      </div>

      <div v-if="isshow" class="doTask">
        <div>
          <van-field label="审批意见" name="radio">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" autosize @input="isMessage=false" label="审批说明" placeholder="请输入审批说明" rows="2"
                       type="textarea"/>
          </van-cell-group>
        </div>
        <div v-if="isMessage" style="color: red">请输入审核意见</div>
        <div style="text-align:center">
          <van-button size="small" style="width: 15%;margin-top: 2%;" type="info" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item name="1" title="基本信息">
<!--        <van-row>-->
<!--          <van-col span="24">-->
<!--            <van-field v-model="inputForm.code" autosize label="包装物料处置退库单据编号" label-width="100px" readonly rows='1'-->
<!--                       type="textarea"/>-->
<!--          </van-col>-->
<!--        </van-row>-->
<!--        <van-row>-->
<!--          <van-col span="24">-->
<!--            <van-field v-model="inputForm.applyDeptName" autosize label="原料果采摘组" label-width="100px" readonly rows='1'-->
<!--                       type="textarea"/>-->
<!--          </van-col>-->
<!--        </van-row>-->
<!--        <van-row>-->
<!--          <van-col span="24">-->
<!--            <van-field v-model="inputForm.operatorName" autosize label="采摘组负责人" label-width="100px" readonly rows='1'-->
<!--                       type="textarea"/>-->
<!--          </van-col>-->
<!--        </van-row>-->
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.businessDate" autosize label="处置日期" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.projectName" autosize label="处置地点" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.disposeTypeName" autosize label="处置方式" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.lendBillCode" autosize label="物料归还单" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.operatorName" autosize label="经办人" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.applyDeptName" autosize label="经办部门" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="24">
            <van-field label="物料信息" label-width="100px" readonly>
              <template #button>
                <van-button plain type="default" @click="view">查看明细</van-button>
              </template>
            </van-field>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
              <p>附件</p>
              <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file,'mater')">{{file.name}}</p>
            </div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.remark" autosize label="备注" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
      </van-collapse-item>
    </van-collapse>
    <!-- <div>{{msg}}</div> -->
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import auditService from '@/api/mater/auditService'
import QueryInfoService from '@/api/system/queryInfoService'
import Vue from "vue";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3', '4'],
      isshow: false,
      isMessage: false,
      isTransact:false,
      isLoading:false,
      radio: '',
      msg: '',
      screen: "横屏",
      inputForm: {
        id: '',
        projectId: '',
        unit: '',
        remarks: '',
        theme: '',
        attachList: [],
        attachIds: [],
        unitPrices: []
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      flowParam: {},
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: '',
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.isMessage=false
    this.isLoading=false
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
      this.flowParam = {
        id: this.procInsId,
        businessId: this.businessId,
        approvalStatus: undefined,
        approvalOpinion: undefined,
      };
    },
    view() {
      this.$router.push({
        path: '/materDispose_detail',
        query: {
          id: this.businessId,
          data: this.inputForm
        }
      })
    },
    init(id) {
      // alert()
      this.$flow.queryByMater(id, '/centerIn/view').then(res => {
        this.msg = JSON.stringify(res)
        this.inputForm = res.data.data
        // 获取审批人
        let queryParams = {
          businessId: this.businessId,
          flowStatus: this.inputForm.auditStatus == '1' ? '1' : this.inputForm.auditStatus == '2' ? '2' : '0',//流程状态
          moduleFlag:"13"
        }
        new QueryInfoService().listMyFlowprocess(queryParams).then(res => {
          this.isTransact = res.data.rows.map(row => row.approvalId).includes(Vue.cookie.get('mater-userId'))
        }).catch(e => {
          console.log(e)
        })
        // 附件转换
        this.inputForm.attachList = this.inputForm.attachments ? JSON.parse(this.inputForm.attachments) : []
        // 日期格式化
        const dates = [
          [this.inputForm.businessDate, 'business'],
        ].map(([userType, formField]) => {
            this.$set(this.inputForm, `${formField}Date`, userType.slice(0,10));
        });
        // 获取项目
        const pros = [
          [this.inputForm.projectId, 'project'],
        ].map(([proType, formField]) => {
          new QueryInfoService().listProject().then(pro => {
            this.$set(this.inputForm, `${formField}Name`, pro.data.data.find(item => item.id == proType).name);
          }).catch(e => {
            console.log(e)
          })
        });
        // 获取部门
        // const depts = [
        //   [this.inputForm.operatorDept, 'operatorDept'],
        // ].map(([deptType, formField]) => {
        //   new QueryInfoService().getDept(deptType).then(dept => {
        //     this.$set(this.inputForm, `${formField}Name`, dept.data.data.deptName);
        //   }).catch(e => {
        //     console.log(e)
        //   })
        // });
        // 获取字典
        const dicts = [
          ['center_dispose_type', 'disposeType'],
        ].map(([dictType, formField]) => {
          new QueryInfoService().getDicts(dictType).then(dict => {
            this.$set(this.inputForm, `${formField}Name`, dict.data.data.find(item => item.dictValue == this.inputForm[formField]).dictLabel);
          }).catch(e => {
            console.log(e)
          })
        });
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.isLoading) {return}
      this.isLoading = true
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.flowParam.approvalStatus = '2'; // 审核状态 [1:未审核;2:已审核-同意;3:已审核-不同意]")
      _this.flowParam.approvalOpinion = _this.auditForm.message;
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new auditService().materFlowConfirm(_this.flowParam).then((res) => {
          if(res.data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('操作成功');
            setTimeout(function () {
              _this.close()
            }, 800)
          } else {
            _this.$toast.clear();
            _this.$toast.fail(res.data.msg);
            setTimeout(function () {
              _this.close()
            }, 800)
          }
        })
      }).catch(() => {
        this.isLoading=false
      })
    },
    reject() {
      let _this = this
      _this.flowParam.approvalStatus = '3'; // 审核状态 [1:未审核;2:已审核-同意;3:已审核-不同意]")
      _this.flowParam.approvalOpinion = _this.auditForm.message;
      //审核不通过时，必须输入审核意见
      if (!_this.flowParam.approvalOpinion) {
        this.isMessage=true
        this.isLoading=false
        return
      }
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new auditService().materFlowConfirm(_this.flowParam).then((res) => {
          if(res.data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('操作成功');
            setTimeout(function () {
              _this.close()
            }, 800)
          } else {
            _this.$toast.clear();
            _this.$toast.fail(res.data.msg);
            setTimeout(function () {
              _this.close()
            }, 800)
          }
        })
      }).catch(() => {
        this.isLoading=false
      })
    }
  }
}
</script>
